import { configure } from "@testing-library/react";
import { createStore } from "redux";
import appReducer from "./Reducer";

//unnecesary comment
const store = createStore(appReducer);

export default store;
